import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { withi18n, DialogueBody } from "../../../../../customer/components";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
const ExpertConversationFinalDialog = ({
  t,
  classes,
  onFinishClick,
  title,
  body,
  buttonText
}) => {
  //if for any reason (rouge IoT) this dialog is closed, execute the onFinishClick
  React.useEffect(() => {
    return () => onFinishClick();
  }, []);
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    title: title,
    onOkClick: () => onFinishClick(),
    okText: buttonText,
    okDisabled: false,
    paperStyle: {
      maxWidth: "567px"
    }
  }, /*#__PURE__*/React.createElement(DialogueBody, {
    body: t(body),
    textStyling: classes.bodyText
  }));
};
const styles = theme => {
  var _theme$palette$backgr;
  return {
    bodyText: {
      color: theme.palette.primary.dark
    },
    paper: {
      width: 550
    },
    container: {
      backgroundColor: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.default,
      marginLeft: 16,
      marginRight: 16,
      padding: "16px !important"
    }
  };
};
export default withStyles(styles)(withi18n(ExpertConversationFinalDialog));
ExpertConversationFinalDialog.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  onFinishClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};